import Joi from 'joi-browser';
import { emailRegex, phoneNumberRegex, stringAllowedCharactersRegex } from 'common/utils/constants';


export const validateEmailNotificationsSchema = {
  notifications: Joi.array().items(
    Joi.string().regex(emailRegex)
  )
};

export const validatePhoneNotificationsSchema = {
  notifications: Joi.array().items(
    Joi.string().regex(phoneNumberRegex).max(14)
  )
};

export const validateNotificationsSchema = {
  notifications: Joi.array().items(
    Joi.alternatives().try(Joi.string().regex(emailRegex), Joi.string().regex(phoneNumberRegex).max(14))
  )
};

export const validateAlertCreationSchema = {
  name: Joi.string().trim().regex(stringAllowedCharactersRegex).min(3).max(100).required(),
  notifications: validateNotificationsSchema.notifications,
  active: Joi.bool().strict().required()
};

export const validateCreateAlert = Joi.object({
  ...validateAlertCreationSchema
}).options({ allowUnknown: true });

/**
 * Geo Filter Schema
 * @type {Joi.ObjectSchema<any>}
 */
const geoFilterValidationSchema = Joi.object({
  polygons: Joi.array().items(
    Joi.object({
      id: Joi.string().required(),
      name: Joi.string()
    })
  ),
  pivots: Joi.array().items(
    Joi.object({
      deviceId: Joi.string().required(),
      name: Joi.string().allow('', null),
      code: Joi.string().allow('', null),
      state: Joi.string().valid('Connected', 'Disconnected', null)
    })
  ),
  devices: Joi.array().items(
    Joi.object({
      deviceId: Joi.string().required(),
      state: Joi.string().valid('Connected', 'Disconnected', null),
      isDonor: Joi.bool()
    })
  )
}).allow(null);

/**
 * Create Rule Schema
 */
export const createRuleValidationConstSchema = Joi.object({
  name: Joi.string().trim().regex(stringAllowedCharactersRegex).min(3).max(100).required(),
  conditions: Joi.array()
    .items(
      Joi.array()
        .items(
          Joi.object({
            id: Joi.string(),
            comparationType: Joi.string().valid('≥', '>', '=', '≠', '<', '≤'),
            source: Joi.object({
              type: Joi.string().valid('calc'),
              metricId: Joi.number().required(),
              geoFilter: geoFilterValidationSchema,
              aggregationType: Joi.string()
                .valid('minimum', 'maximum', 'average', 'standard_deviation').allow(null),
              time: Joi.object().allow(null)
            }),
            target: {
              type: Joi.string().valid('calc', 'const'),
              value: Joi.number().empty('').allow(null).required()
            }
          }).options({ allowUnknown: true })
        )
        .min(1)
    )
    .min(1)
    .required()
});

export const createRuleValidationCalcSchema = Joi.object({
  name: Joi.string().trim().regex(stringAllowedCharactersRegex).min(3).max(100).required(),
  conditions: Joi.array()
    .items(
      Joi.array()
        .items(
          Joi.object({
            id: Joi.string(),
            comparationType: Joi.string().valid('≥', '>', '=', '≠', '<', '≤'),
            source: Joi.object({
              type: Joi.string().valid('calc'),
              metricId: Joi.number().required(),
              geoFilter: geoFilterValidationSchema,
              aggregationType: Joi.string()
                .valid('minimum', 'maximum', 'average', 'standard_deviation').allow(null),
              time: Joi.object().allow(null)
            }),
            target: {
              type: Joi.string().valid('calc', 'const'),
              metricId: Joi.number().required(),
              geoFilter: geoFilterValidationSchema,
              delta: Joi.number().allow(''),
              aggregationType: Joi.string()
                .valid('minimum', 'maximum', 'average', 'standard_deviation')
                .required(),
              time: Joi.object().allow(null)
            }
          }).options({ allowUnknown: true })
        )
        .min(1)
    )
    .min(1)
    .required()
});
